(() => {
  'use strict';
  const controls = document.querySelector('[id^="dc-category-controls-"][data-dc-game="Pokémon"]');
  const container = document.getElementById('ProductGridContainer');
  const aside = document.getElementById('main-collection-filters');
  if (!controls || !container || !aside) return;
  const boxes = Array.from(controls.querySelectorAll('[data-dc-format]'));
  const language = controls.querySelector('[data-dc-language]');
  if (!language || !boxes.length) return;
  const base = new URL(controls.dataset.collectionUrl, location.origin);
  const game = controls.dataset.dcGame;
  const sectionId = aside.dataset.id;
  const normalize = value => String(value).normalize('NFKC').toLowerCase();
  const cursorCache = new Map();
  let nativeInitial = true;
  let generation = 0;
  let requestController;
  let countController;
  let timer;
  let lastCountKey = '';

  function clean(params) {
    ['filter.v.price.gte', 'filter.v.price.lte'].forEach(name => {
      const values = params.getAll(name).filter(value => value.trim() !== '');
      params.delete(name);
      values.forEach(value => params.append(name, value));
    });
  }
  function readState(url) {
    const params = new URLSearchParams(url.search);
    clean(params);
    const formats = params.getAll('dc_format');
    const suffix = decodeURIComponent(url.pathname.slice(base.pathname.replace(/\/$/, '').length)).replace(/^\/|\/$/g, '');
    const legacy = [...params.getAll('filter.p.tag'), ...suffix.split('+')];
    let lang = params.get('dc_language') || '';
    legacy.forEach(tag => {
      const box = boxes.find(box => normalize(box.value) === normalize(tag) || normalize(box.dataset.dcTagHandle) === normalize(tag));
      if (box && !formats.includes(box.value)) formats.push(box.value);
      const option = Array.from(language.options).find(option => option.value && normalize(option.value) === normalize(tag));
      if (option && !lang) lang = option.value;
    });
    const page = Math.max(1, Number(params.get('dc_page') || params.get('page') || 1) || 1);
    return { params, formats: [...new Set(formats)], language: lang, page: Math.floor(page) };
  }
  let state = readState(new URL(location.href));

  function publicUrl() {
    const url = new URL(location.href);
    url.pathname = base.pathname;
    url.search = state.params.toString();
    ['filter.p.tag', 'dc_format', 'dc_language', 'dc_page', 'page', 'section_id', 'q', 'type'].forEach(name => url.searchParams.delete(name));
    state.formats.forEach(value => url.searchParams.append('dc_format', value));
    if (state.language) url.searchParams.set('dc_language', state.language);
    if (state.page > 1) url.searchParams.set('dc_page', String(state.page));
    return url;
  }
  const canonical = publicUrl();
  if (new URL(location.href).pathname !== canonical.pathname || new URL(location.href).searchParams.has('filter.p.tag')) {
    location.replace(canonical.href);
    return;
  }
  window.dcCollectionFiltersActive = true;

  const status = document.createElement('p');
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  container.prepend(status);
  const badge = document.createElement('div');
  badge.dataset.dcActiveStock = '';
  const activeArea = aside.querySelector('.active-facets-desktop');
  if (activeArea) {
    Array.from(activeArea.children).filter(child => child.tagName.toLowerCase() === 'facet-remove').forEach(child => child.remove());
    activeArea.append(badge);
  }

  function syncInputs() {
    boxes.forEach(box => { box.checked = state.formats.includes(box.value); });
    language.value = state.language;
    document.querySelectorAll('facet-filters-form input[name="filter.v.availability"]').forEach(input => {
      input.checked = state.params.getAll('filter.v.availability').includes(input.value);
    });
    document.querySelectorAll('facet-filters-form input[name^="filter.v.price."]').forEach(input => {
      input.value = state.params.get(input.name) || '';
    });
    badge.replaceChildren();
    [...new Set(state.params.getAll('filter.v.availability'))].forEach(value => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'active-facets__button button button--tertiary';
      button.textContent = (value === '1' ? 'En existencia' : 'Agotado') + ' ×';
      button.addEventListener('click', () => {
        const remaining = state.params.getAll('filter.v.availability').filter(item => item !== value);
        state.params.delete('filter.v.availability');
        remaining.forEach(item => state.params.append('filter.v.availability', item));
        state.page = 1;
        commit();
      });
      badge.append(button);
    });
    const minimum = state.params.get('filter.v.price.gte');
    const maximum = state.params.get('filter.v.price.lte');
    if (minimum || maximum) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'active-facets__button button button--tertiary';
      button.textContent = 'Precio: ' + (minimum || '0') + ' – ' + (maximum || 'sin límite') + ' ×';
      button.addEventListener('click', () => {
        state.params.delete('filter.v.price.gte');
        state.params.delete('filter.v.price.lte');
        state.page = 1;
        commit();
      });
      badge.append(button);
    }
  }

  function queryFor(formats) {
    const clauses = ['tag:' + JSON.stringify(game)];
    if (formats.length) clauses.push('(' + formats.map(value => 'tag:' + JSON.stringify(value)).join(' OR ') + ')');
    if (state.language) {
      const option = Array.from(language.options).find(option => option.value === state.language);
      if (!option) throw new Error('Idioma no reconocido');
      clauses.push('tag:' + JSON.stringify(option.textContent.trim()));
    }
    const stock = [...new Set(state.params.getAll('filter.v.availability'))];
    if (stock.length === 1) clauses.push(stock[0] === '1' ? 'available_for_sale:true' : 'NOT available_for_sale:true');
    [['filter.v.price.gte', '>='], ['filter.v.price.lte', '<=']].forEach(([name, operator]) => {
      const value = state.params.get(name);
      if (!value || !value.trim()) return;
      const number = Number(value);
      if (!Number.isFinite(number) || number < 0) throw new Error('Precio no válido');
      if (window.Shopify && Shopify.currency && Shopify.currency.active !== 'EUR') throw new Error('El filtro de precio necesita validación para esta moneda');
      clauses.push('variants.price:' + operator + number);
    });
    return clauses.join(' AND ');
  }

  const PAGE_SIZE = 20;
  const apiUrl = new URL('/api/2026-10/graphql.json', location.origin);
  const sortMap = {
    'price-ascending': ['PRICE', false], 'price-descending': ['PRICE', true],
    'title-ascending': ['TITLE', false], 'title-descending': ['TITLE', true],
    'created-ascending': ['CREATED_AT', false], 'created-descending': ['CREATED_AT', true],
    'best-selling': ['BEST_SELLING', false], 'relevance': ['RELEVANCE', false],
    'most-relevant': ['RELEVANCE', false], 'manual': ['RELEVANCE', false]
  };
  async function catalogPage(expression, first, after, signal, idsOnly) {
    const sort = sortMap[state.params.get('sort_by')] || ['ID', false];
    const country = String((window.Shopify && Shopify.country) || 'ES').toUpperCase();
    const context = /^[A-Z]{2}$/.test(country) ? ' @inContext(country: ' + country + ')' : '';
    const query = 'query' + context + ' { products(first:' + first + ',query:' + JSON.stringify(expression) + ',sortKey:' + sort[0] + ',reverse:' + sort[1] + (after ? ',after:' + JSON.stringify(after) : '') + ') { nodes { id' + (idsOnly ? '' : ' handle availableForSale') + ' } pageInfo { hasNextPage endCursor } } }';
    const response = await fetch(apiUrl.href, { method: 'POST', credentials: 'same-origin', signal, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ query }) });
    if (!response.ok) throw new Error('Catálogo: respuesta ' + response.status);
    const body = await response.json();
    if (body.errors && body.errors.length) throw new Error(body.errors.map(error => error.message).join('; '));
    const connection = body.data && body.data.products;
    if (!connection || !Array.isArray(connection.nodes) || !connection.pageInfo) throw new Error('Respuesta de catálogo incompleta');
    if (!idsOnly) {
      const stockMatch = expression.match(/(?:^| AND )(NOT )?available_for_sale:true(?: AND |$)/);
      if (stockMatch) {
        const expected = !stockMatch[1];
        if (connection.nodes.some(product => product.availableForSale !== expected)) throw new Error('El catálogo no respeta el filtro de disponibilidad; no se sustituye el listado');
      }
    }
    return connection;
  }
  async function catalogCount(expression, signal) {
    let cursor = null;
    const ids = new Set();
    const seenCursors = new Set();
    for (let pages = 0; pages < 40; pages++) {
      const result = await catalogPage(expression, 250, cursor, signal, true);
      result.nodes.forEach(product => ids.add(product.id));
      if (!result.pageInfo.hasNextPage) return ids.size;
      cursor = result.pageInfo.endCursor;
      if (!cursor || seenCursors.has(cursor)) throw new Error('Cursor de recuento no válido');
      seenCursors.add(cursor);
    }
    throw new Error('Recuento demasiado grande; no se muestra un total parcial');
  }
  function requestUrl(section, formats, page) {
    const url = new URL(base.href);
    url.pathname = base.pathname.split('/collections/')[0] + '/search';
    url.search = state.params.toString();
    ['filter.p.tag', 'dc_format', 'dc_language', 'dc_page', 'page', 'section_id', 'q', 'type'].forEach(name => url.searchParams.delete(name));
    clean(url.searchParams);
    url.searchParams.set('q', queryFor(formats));
    url.searchParams.set('type', 'product');
    url.searchParams.set('section_id', section);
    if (page) url.searchParams.set('page', String(page));
    const sort = url.searchParams.get('sort_by');
    if (!sort || ['manual', 'most-relevant', 'best-selling'].includes(sort)) url.searchParams.set('sort_by', 'relevance');
    return url;
  }
  async function fragment(url, signal) {
    const response = await fetch(url.href, { signal, credentials: 'same-origin' });
    if (!response.ok) throw new Error('Respuesta ' + response.status);
    const text = await response.text();
    return new DOMParser().parseFromString(text, 'text/html');
  }
  function writeHistory(replace) {
    const url = publicUrl();
    if (!replace && url.href === location.href) return;
    history[replace ? 'replaceState' : 'pushState']({ dcCollection: true }, '', url.href);
  }

  function updateStock(root) {
    const counts = { '1': root.dataset.available, '0': root.dataset.unavailable };
    aside.querySelectorAll('input[name="filter.v.availability"]').forEach(input => {
      const count = counts[input.value];
      if (!/^\d+$/.test(count || '')) return;
      const label = input.closest('label');
      const text = label && label.querySelector('span[aria-hidden="true"]');
      if (text) text.textContent = text.textContent.replace(/\s*\([^)]*\)\s*$/, '') + ' (' + count + ')';
    });
    const selectedCount = state.params.getAll('filter.v.availability').length;
    aside.querySelectorAll('.js-filter').forEach(detail => {
      if (!detail.querySelector('input[name="filter.v.availability"]')) return;
      const label = detail.querySelector('.facets__selected');
      if (label) {
        label.textContent = ' (' + selectedCount + ')';
        label.classList.toggle('hidden', !selectedCount);
      }
    });
  }

  function draw(root) {
    const total = Number(root.dataset.total);
    const pages = Number(root.dataset.pages);
    const cards = root.querySelector('[data-dc-cards]');
    if (!Number.isInteger(total) || total < 0 || !Number.isInteger(pages) || pages < 0 || !cards) throw new Error('Respuesta interna incompleta');
    if (total > 0 && !cards.children.length) throw new Error('La respuesta no contiene tarjetas de producto');
    if (pages && state.page > pages) {
      state.page = pages;
      writeHistory(true);
      load();
      return;
    }
    const originalGrid = container.querySelector('#product-grid');
    const grid = document.createElement('div');
    grid.id = 'product-grid';
    grid.dataset.id = sectionId;
    grid.className = originalGrid && originalGrid.classList.contains('product-grid') ? originalGrid.className : 'product-grid row';
    grid.innerHTML = cards.innerHTML;
    const collection = document.createElement('div');
    collection.id = 'collection-product';
    collection.className = 'collection';
    collection.append(grid);
    if (!total) {
      const empty = document.createElement('p');
      empty.textContent = 'No hay productos que coincidan con estos filtros.';
      collection.append(empty);
    }
    if (pages > 1) {
      const nav = document.createElement('nav');
      nav.className = 'pagination-wrapper';
      nav.setAttribute('aria-label', 'Páginas de productos');
      const list = document.createElement('ul');
      list.className = 'pagination__list list-unstyled';
      function button(text, page, disabled) {
        const item = document.createElement('li');
        const control = document.createElement('button');
        control.type = 'button';
        control.className = 'pagination__item link';
        control.textContent = text;
        control.disabled = disabled;
        control.addEventListener('click', () => {
          state.page = page;
          writeHistory(false);
          load();
        });
        item.append(control);
        list.append(item);
      }
      button('Anterior', state.page - 1, state.page === 1);
      const currentItem = document.createElement('li');
      const currentLabel = document.createElement('span');
      currentLabel.className = 'pagination__item';
      currentLabel.textContent = state.page + ' / ' + pages;
      currentItem.append(currentLabel);
      list.append(currentItem);
      button('Siguiente', state.page + 1, state.page === pages);
      nav.append(list);
      collection.append(nav);
    }
    const old = container.querySelector('.collection');
    if (old) old.replaceWith(collection);
    else container.append(collection);
    ['ProductCount', 'ProductCountDesktop'].forEach(id => {
      const element = document.getElementById(id);
      if (element) element.textContent = total + ' productos';
    });
    updateStock(root);
    try {
      const options = JSON.parse(root.dataset.sortOptions || '[]');
      if (options.length) document.querySelectorAll('facet-filters-form select[name="sort_by"]').forEach(select => {
        const previous = state.params.get('sort_by');
        select.replaceChildren(...options.map(option => {
          const element = document.createElement('option');
          element.value = option.value;
          element.textContent = option.name;
          return element;
        }));
        select.value = options.some(option => option.value === previous) ? previous : 'relevance';
      });
    } catch (error) { /* Sort controls stay usable if metadata is absent. */ }
    status.textContent = '';
    container.removeAttribute('aria-busy');
  }

  async function refreshCounts() {
    const key = queryFor([]);
    if (key === lastCountKey) return;
    lastCountKey = key;
    if (countController) countController.abort();
    countController = new AbortController();
    const signal = countController.signal;
    let index = 0;
    async function worker() {
      while (index < boxes.length && !signal.aborted) {
        const box = boxes[index++];
        const count = box.closest('label').querySelector('[data-dc-count]');
        if (!count) continue;
        count.textContent = '(…)';
        try {
          const value = String(await catalogCount(queryFor([box.value]), signal));
          if (signal.aborted) return;
          count.textContent = '(' + value + ')';
          count.setAttribute('aria-label', value + ' productos');
        } catch (error) {
          if (signal.aborted) return;
          count.textContent = '(—)';
          count.setAttribute('aria-label', 'Recuento no disponible');
        }
      }
    }
    await Promise.all([worker(), worker()]);
  }

  async function load() {
    const id = ++generation;
    if (requestController) requestController.abort();
    requestController = new AbortController();
    const signal = requestController.signal;
    container.setAttribute('aria-busy', 'true');
    status.textContent = 'Actualizando productos…';
    try {
      if (!state.formats.length && !state.language) {
        if (nativeInitial) {
          nativeInitial = false;
        } else {
          const url = new URL(base.href);
          url.search = state.params.toString();
          ['filter.p.tag', 'dc_format', 'dc_language', 'dc_page', 'page', 'section_id', 'q', 'type'].forEach(name => url.searchParams.delete(name));
          url.searchParams.set('section_id', sectionId);
          if (state.page > 1) url.searchParams.set('page', String(state.page));
          const doc = await fragment(url, signal);
          if (id !== generation) return;
          const incoming = doc.querySelector('#ProductGridContainer .collection');
          const old = container.querySelector('.collection');
          if (!incoming || !old) throw new Error('Respuesta de colección incompleta');
          old.replaceWith(incoming);
          ['ProductCount', 'ProductCountDesktop'].forEach(name => {
            const incomingCount = doc.getElementById(name);
            const existingCount = document.getElementById(name);
            if (incomingCount && existingCount) existingCount.innerHTML = incomingCount.innerHTML;
          });
          const incomingAside = doc.getElementById('main-collection-filters');
          if (incomingAside) {
            const counts = {};
            incomingAside.querySelectorAll('input[name="filter.v.availability"]').forEach(input => {
              const label = input.closest('label');
              const span = label && label.querySelector('span[aria-hidden="true"]');
              const match = span && span.textContent.match(/\((\d+)\)\s*$/);
              if (match) counts[input.value === '1' ? 'available' : 'unavailable'] = match[1];
            });
            updateStock({ dataset: counts });
          }
        }
        container.removeAttribute('aria-busy');
        status.textContent = '';
        refreshCounts().catch(console.error);
        return;
      }
      nativeInitial = false;
      const expression = queryFor(state.formats);
      const sort = state.params.get('sort_by') || 'manual';
      const cursorKey = expression + '|' + sort;
      const requestedPage = state.page;
      let cursor = cursorCache.get(cursorKey + '|' + requestedPage);
      if (requestedPage > 1 && cursor === undefined) {
        cursor = null;
        for (let page = 1; page < requestedPage; page++) {
          const previous = await catalogPage(expression, PAGE_SIZE, cursor, signal, false);
          if (!previous.pageInfo.hasNextPage) {
            state.page = page;
            cursorCache.set(cursorKey + '|' + page, cursor);
            writeHistory(true);
            break;
          }
          cursor = previous.pageInfo.endCursor;
          cursorCache.set(cursorKey + '|' + (page + 1), cursor);
        }
      }
      const [result, total] = await Promise.all([catalogPage(expression, PAGE_SIZE, cursor || null, signal, false), catalogCount(expression, signal)]);
      if (id !== generation) return;
      if (result.pageInfo.hasNextPage) cursorCache.set(cursorKey + '|' + (state.page + 1), result.pageInfo.endCursor);
      if (cursorCache.size > 150) cursorCache.clear();
      const handles = result.nodes.map(product => product.handle);
      if (handles.some(handle => !handle || !/^[^|\/?#\s]+$/u.test(handle))) throw new Error('Handle de producto no válido');
      let root;
      if (handles.length) {
        const url = new URL(base.href);
        url.pathname = base.pathname.split('/collections/')[0] + '/search';
        url.search = '';
        url.searchParams.set('q', 'dc-handles|' + handles.join('|'));
        url.searchParams.set('section_id', 'dc-search-grid');
        const doc = await fragment(url, signal);
        root = doc.getElementById('dc-search-grid');
        if (!root) throw new Error('Falta la versión de catálogo de sections/dc-search-grid.liquid');
        const actualIds = JSON.parse(root.dataset.productIds || '[]').map(String).sort();
        const expectedIds = result.nodes.map(product => product.id.split('/').pop()).sort();
        if (JSON.stringify(actualIds) !== JSON.stringify(expectedIds) || root.querySelectorAll('[data-dc-cards] > .grid__item').length !== expectedIds.length) throw new Error('Las tarjetas no corresponden a los IDs del catálogo; no se sustituye el listado');
      } else {
        root = document.createElement('div');
        root.innerHTML = '<div data-dc-cards></div>';
      }
      if (id !== generation) return;
      root.dataset.total = String(total);
      root.dataset.pages = String(Math.ceil(total / PAGE_SIZE));
      draw(root);
      refreshCounts().catch(console.error);
      const stockExpression = expression.replace(/ AND (?:NOT )?available_for_sale:(true|false)/g, '');
      Promise.all([catalogCount(stockExpression + ' AND available_for_sale:true', signal), catalogCount(stockExpression + ' AND NOT available_for_sale:true', signal)]).then(([available, unavailable]) => {
        if (id === generation && !signal.aborted) updateStock({ dataset: { available: String(available), unavailable: String(unavailable) } });
      }).catch(error => { if (!signal.aborted) console.error('DuneCards: recuento de stock', error); });
    } catch (error) {
      if (id !== generation || signal.aborted) return;
      container.removeAttribute('aria-busy');
      status.textContent = 'No se pudo actualizar. Se mantienen los resultados anteriores. ' + error.message;
      console.error('DuneCards: filtros de colección', error);
    }
  }
  function commit() {
    ++generation;
    if (requestController) requestController.abort();
    clean(state.params);
    if (countController) countController.abort();
    lastCountKey = '';
    syncInputs();
    writeHistory(false);
    clearTimeout(timer);
    timer = setTimeout(load, 180);
  }

  function onInput(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (controls.contains(target)) {
      event.stopImmediatePropagation();
      event.preventDefault();
      state.formats = boxes.filter(box => box.checked).map(box => box.value);
      state.language = language.value;
    } else {
      const form = target.closest('facet-filters-form form');
      if (!form || (!aside.contains(form) && !container.contains(form))) return;
      const name = target.name;
      if (!name || (!name.startsWith('filter.') && name !== 'sort_by')) return;
      event.stopImmediatePropagation();
      event.preventDefault();
      state.params.delete(name);
      if (target.type === 'checkbox') {
        form.querySelectorAll('input[type="checkbox"]').forEach(input => {
          if (input.name === name && input.checked) state.params.append(name, input.value);
        });
      } else if (target.value.trim() !== '') state.params.set(name, target.value);
    }
    state.page = 1;
    commit();
  }
  document.addEventListener('input', onInput, true);
  document.addEventListener('change', onInput, true);
  document.addEventListener('click', event => {
    const link = event.target.closest('facet-remove a');
    if (!link || !aside.contains(link)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (link.classList.contains('active-facets__button-remove')) {
      ['filter.v.availability', 'filter.v.price.gte', 'filter.v.price.lte'].forEach(name => state.params.delete(name));
      state.formats = [];
      state.language = '';
    } else {
      const next = new URL(link.href);
      ['filter.v.availability', 'filter.v.price.gte', 'filter.v.price.lte'].forEach(name => {
        state.params.delete(name);
        next.searchParams.getAll(name).forEach(value => state.params.append(name, value));
      });
    }
    state.page = 1;
    syncInputs();
    commit();
  }, true);
  window.addEventListener('popstate', event => {
    event.stopImmediatePropagation();
    if (new URL(location.href).pathname !== base.pathname) {
      location.reload();
      return;
    }
    state = readState(new URL(location.href));
    syncInputs();
    load();
  }, true);
  window.addEventListener('pagehide', () => {
    if (requestController) requestController.abort();
    if (countController) countController.abort();
  }, { once: true });
  syncInputs();
  writeHistory(true);
  load();
})();
